import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=22696d6a&scoped=true&"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundLayout.vue?vue&type=style&index=0&id=22696d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22696d6a",
  null
  
)

export default component.exports